import { Component } from '@angular/core';
import { ResizeDetectionService } from '../../services/resize-detection.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent {
  cookiePopupVisibility: boolean = false;
  customCookiePopupVisibility: boolean = false;
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;

  constructor(private sizedetection: ResizeDetectionService) {}
  
  ngOnInit() {
    if (localStorage.getItem('cookie')) {
      this.cookiePopupVisibility = false;
    } else this.cookiePopupVisibility = true;
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
        this.isDesktop = data.isDesktop;
        this.isTablet = data.isTablet;
        this.isMobile = data.isMobile;

    });
  }

  acceptCookie() {
    localStorage.setItem('cookie', "1");
    this.cookiePopupVisibility = false;
  }
  customizeCookie() {
    this.cookiePopupVisibility = false;
    this.customCookiePopupVisibility = true;
  }
  rejectCookie() {
    this.cookiePopupVisibility = false;
  }
  acceptCookieOpen() {
    localStorage.setItem('cookie', "1");
    this.cookiePopupVisibility = false;
  }
  customizeCookieOpen() {
    localStorage.setItem('cookie', "1");
    this.customCookiePopupVisibility = false;
  }
  rejectCookieOpen() {
    this.customCookiePopupVisibility = true;
  }
}
